import React, { useState } from "react";

import {
  Container,
  Content,
  ActionsContent,
  CancelButton,
  ConfirmButton,
  ModalConfirmText,
  Divider,
} from "./styles";

import deleteIcon from "@assets/deleteIcon.svg";
import Loading from "../../Loading/Loading";
import { Client } from "@domain/models/Client";
import { RemoveClientFromMapUseCase } from "@useCases/index";
import { HttpClientRepository } from "@data/repositories/index";
import { api } from "@data/api";
import { MapClient } from "@domain/models/MapClient";

type Props = {
  client: Client | MapClient;
  onCancel: () => void;
  onSuccess: () => void;
};

const ModalRemoveClient = ({ client, onCancel, onSuccess }: Props) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);

    const useCase = new RemoveClientFromMapUseCase(new HttpClientRepository(api));

    useCase
      .execute(client.id)
      .then(() => {
        onSuccess();
      })
      .catch(() => {
        onCancel();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      <Content>
        <img src={deleteIcon} style={{ height: 80, width: 80 }} alt="map map" />
        <ModalConfirmText>Tem certeza que deseja excluir {client.name} do mapa?</ModalConfirmText>
      </Content>
      <Divider />
      <ActionsContent>
        {loading ? (
          <Loading />
        ) : (
          <>
            <CancelButton onClick={onCancel}>
              <p>Voltar</p>
            </CancelButton>
            <ConfirmButton onClick={() => handleConfirm()}>
              <p>Excluir</p>
            </ConfirmButton>
          </>
        )}
      </ActionsContent>
    </Container>
  );
};

export default ModalRemoveClient;
